import { login, logout, getUserInfo } from '@/api/user';
import { setToken, getToken } from '@/libs/util';
import axios from '@/libs/api.request';
import { TUILogin } from '@tencentcloud/tui-core';
import { framework } from '@/TUIKit/adapter-vue';

export default {
  state: {
    userName: '',
    userId: '',
    avatarImgPath: '',
    token: getToken(),
    access: '',
    hasGetInfo: false,
    myInfo: {},
    userProfile: {},
    blacklist: [],
    timPrefix: '',
    totalUnreadCount: 0,
    totalHelpCount: 0,
    imUserId: '',
    firstTalk: true,
    talkUserId: ''
  },
  getters: {
    myInfo: state => state.myInfo,
    userProfile: state => state.userProfile,
    imUserId: state => state.imUserId,
    firstTalk: state => state.firstTalk,
    talkUserId: state => state.talkUserId
  },
  mutations: {
    setAvatar(state, avatarPath) {
      state.avatarImgPath = avatarPath;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    setAccess(state, access) {
      state.access = access;
    },
    setToken(state, token) {
      state.token = token;
      setToken(token);
    },
    setHasGetInfo(state, status) {
      state.hasGetInfo = status;
    },
    updateMyInfo(state, myInfo) {
      state.myInfo = myInfo;
    },
    updateUserProfile(state, userProfile) {
      state.userProfile = userProfile;
    },
    setBlacklist(state, blacklist) {
      state.blacklist = blacklist;
    },
    updateBlacklist(state, blacklist) {
      state.blacklist.push(blacklist);
    },
    resetUser(state) {
      state.blacklist = [];
      state.userProfile = {};
      state.myInfo = {};
    },
    setTimPrefix(state, prefix) {
      state.timPrefix = prefix;
    },
    setTotalUnreadCount(state, count) {
      state.totalUnreadCount = count;
    },
    setTotalHelpCount(state, count) {
      state.totalHelpCount = count;
    },
    setImUserId(state, id) {
      state.imUserId = id;
    },
    setFirstTalk(state) {
      state.firstTalk = !state.firstTalk;
    },
    setTalkUserId(state, id) {
      state.talkUserId = id;
    }
  },
  actions: {
    // 获取就业帮扶报名待处理数据
    getHelpCount({ commit }) {
      axios
        .request({
          url: 'front/v1/company/help-user-plan-project',
          method: 'get',
          params: { status: 1 }
        })
        .then(res => {
          commit('setTotalHelpCount', res.data.count);
        });
    },
    // 登录
    handleLogin({ commit }, { identity, phone, code, type }) {
      return new Promise((resolve, reject) => {
        axios
          .request({
            url: 'front/v1/common/mockLogin?username=' + phone + '&scope=company',
            method: 'post'
          })
          .then(res => {
            const data = res.data;
            commit('setToken', data);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
        // login({
        //   identity,
        //   phone,
        //   code,
        //   type
        // })
        //   .then(res => {

        //   })
        //   .catch(err => {
        //     reject(err);
        //   });
      });
    },
    // 退出登录
    handleLogOut({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('setToken', '');
        commit('setAccess', []);
        commit('updateUserProfile', {});
        TUILogin.logout();
        if (localStorage.getItem('mode')) {
          localStorage.removeItem('mode');
          localStorage.removeItem('superGonghui');
        }
        window.location.reload();
        resolve();
        // logout(state.token)
        //   .then(() => {
        //     commit("setToken", "");
        //     commit("setAccess", []);
        //     commit("updateUserProfile", {});
        //     if (localStorage.getItem("mode")) {
        //       localStorage.removeItem("mode");
        //       localStorage.removeItem("superGonghui");
        //     }
        //     resolve();
        //   })
        //   .catch(err => {
        //     reject(err);
        //   });
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        // commit('setToken', '')
        // commit('setAccess', [])
        // resolve()
      });
    },
    // 获取用户相关信息
    getUserInfo({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          getUserInfo(state.token)
            .then(res => {
              const data = res.data;
              commit('setAvatar', data.avatar);
              commit('setUserName', data.nickname);
              commit('setUserId', data.id);
              commit('setAccess', data.access);
              commit('setHasGetInfo', true);
              commit('updateUserProfile', data);
              commit('updateMyInfo', data);
              if (data.isCompanyMainAdmin) {
                commit('setAccess', ['isCompanyMainAdmin']);
              }
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } catch (error) {
          reject(error);
        }
      });
    }
  }
};
